import { render, staticRenderFns } from "./Secure.vue?vue&type=template&id=10dfa526&"
import script from "./Secure.vue?vue&type=script&lang=js&"
export * from "./Secure.vue?vue&type=script&lang=js&"
import style0 from "./Secure.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports